export const MRF_DETAILS = "MRF_DETAILS";
export const MRF_DETAILS_BY_GATE = "MRF_DETAILS_BY_GATE";
